import constant from '../../constant'

const initialState = {
  clipboardData: ''
};

export function clipboard (state = initialState, action) {
  switch (action.type) {
    case constant.E_COMMERCE_FISSION.CLIPBOARD:
      return {
        ...state,
        ...action
      }
    default:
      return state
  }
}